import { createContext } from "react";
import { RelayerCtx } from "./types";

export const RelayerContext = createContext({} as RelayerCtx);
